export var FetchStatus = /*#__PURE__*/ function(FetchStatus) {
    FetchStatus["None"] = "none";
    FetchStatus["Loading"] = "loading";
    FetchStatus["Loaded"] = "loaded";
    FetchStatus["Partial"] = "partial";
    FetchStatus["Error"] = "error";
    return FetchStatus;
}({});
export var SchemaKeys = /*#__PURE__*/ function(SchemaKeys) {
    SchemaKeys["Home"] = "home";
    SchemaKeys["Projects"] = "projects";
    SchemaKeys["Tasks"] = "tasks";
    SchemaKeys["Sprints"] = "sprints";
    SchemaKeys["SpaceTabs"] = "spaceTabs";
    SchemaKeys["Spaces"] = "spaces";
    return SchemaKeys;
}({});
export var ActorName = /*#__PURE__*/ function(ActorName) {
    ActorName["TaskCard"] = "task_card";
    ActorName["TaskDrawer"] = "task_drawer";
    return ActorName;
}({});
